<div class="container">
  <header>
    <div class="logos-container">
      <div class="logo">
        <img *ngIf="showBackButton" class="logo-back" src="assets/frame2.png" (click)="goBack()" /> 
        <img class="logo-title" [src]="utilityLogo || 'assets/Frame 1 .png'" (click)="navigateTo('provider-dash')"  />
      </div>
  

      <div class="dropdown">
      <div class="date-container">
        <p>{{toDate()}}</p>
        <div class="header-icon">
          <img class="header-img" src="assets/Group 592 (1).svg" />
        </div>
        
        <div class="dropdown-content">
          <a class="dropdown-item" (click)="logout()">Logout</a>
        </div>
      </div>
    </div>

    </div>
    <div class="title">Peer to Peer Energy Trading Platform, {{title}}</div>
  </header>


  <router-outlet></router-outlet>

  <footer class="dashboard-footer">
    Powered by Hygge
  </footer>
</div>
